import React from 'react'
import { Chart } from 'primereact/chart'

function LineChartV1({ data, animate = true }) {

    const options = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        animation: animate,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    color: "#363535"
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: "#363535"
                },
                grid: {
                    color: "#EBEDED"
                }
            },
            y: {
                ticks: {
                    color: "#363535"
                },
                grid: {
                    color: "#EBEDED"
                }
            }
        }
    }

    return (
        <>
            <Chart type="line" data={data} options={options} style={{ height: '400px' }} />
        </>
    )
}

export default React.memo(LineChartV1)